import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@chakra-ui/react";
import SidebarWithHeader from "./SidebarWithHeader";

export default function Layout() {
  return (
    <>
      <SidebarWithHeader expand="lg" />
      <Box
        as="main"
        pt="var(--header-height, 80px)" // add padding to as placeholder for header
        ps={{ base: "0", lg: "var(--sidebar-width, 300px)" }} // add padding start as placeholder for sidebar
      >
        <Suspense>
          <Outlet />
        </Suspense>
      </Box>
    </>
  );
}
